export class ApprovalPath {
    constructor(
        public id?: number,
        public possibleAction?: string,
        public status?: string | any,
        public step?: string | any,
    ) { }

    static adapt(item: any): ApprovalPath {
        return new ApprovalPath(
            item.id,
            item.possibleAction,
            item.status,
            item.step,
        );
    }
}
